// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8f514721","239":"37d5e792","553":"fdfffd8c"}[chunkId] + ".chunk.js";
};